import React, { useState, useEffect } from "react";
import MonitoringAddressInfoForm from "./MonitoringAddressInfoForm";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../store";
import { CAProvinces, stateList } from "../../../../util/CommonLists";
import { MonitoringData } from "../../../../store/common";
import { useTranslation } from "react-i18next";
import RenderIcons from "../../../../Assets/css/_icons/partner_icon/RenderIcons";

const MonitoringAddressInfo: React.FunctionComponent<{ monitoringData: MonitoringData; ensureDataFetch: any }> = (props) => {
    const [personalAssets, setPersonalAssets] = useState();
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [addressInfo, setAddressInfo] = useState({});
    const [showForm, setShowForm] = useState(false);
    const [info, setInfo]: any = useState({});
    const [isLoading, setisLoading] = useState(false);

    let isIDFUser = useSelector((state: ApplicationState) => {
        if (state.creditAuthData.authData != null) {
            return state.creditAuthData.authData.isIDFUser;
        }
        return "";
    });

    const ensureDataFetched = () => {
        setisLoading(true);
        props.ensureDataFetch();
    };

    useEffect(() => {
        // if (!showForm)
        // getMonitoringInfo().then((data: any) => {
        setInfo(props.monitoringData);
        const dataAsset = props.monitoringData.asset;
        setPersonalAssets(dataAsset.personalInformation);
        setAddressInfo(dataAsset.addressInformation);
        setisLoading(false);
        // });
    }, [props.monitoringData]);

    const [formData, setFormData] = useState({
        address1: "this is street",
        address2: "",
        address3: "",
        city: "Los angelas",
        state: "california",
        zipcode: 90262,
        "ezshield-id": "",
        "idf-user-id": "",
        country: "",
    });

    useEffect(() => {
        const data: any = addressInfo;
        setFormData({
            "ezshield-id": info && info["ezshield-id"],
            "idf-user-id": info && info["idf-user-id"],
            address1: data && data["address-street"] ? data["address-street"] : "",
            address2: data && data["address-street2"] ? data["address-street2"] : "",
            address3: data && data["address-street3"] ? data["address-street3"] : "",
            city: data && data && data["address-city"] ? data["address-city"] : "",
            state: data && data["address-state"] ? data["address-state"] : "",
            zipcode: data && data["address-code"] ? data["address-code"] : "",
            country: data && data["address-country"] ? data["address-country"] : "",
        });
    }, [addressInfo]);

    return (
        <div className={`box offset-padding ${isLoading && "loading"}`}>
            <div className="box-header">
                <div className="box-title-container">
                    <div className="box-title-icon" aria-hidden="true">
                        <RenderIcons iconName="map-marker" />
                    </div>
                    <div className="box-title-text has-actions">
                        <h2 className="box-title">{tLang("identityVault.monitoredInformation.addressWidget.title")}</h2>
                    </div>
                </div>
                {!showForm && (
                    <div className="box-actions" onClick={() => setShowForm(true)}>
                        <button
                            type="button"
                            className="btn-default btn-grey-dot"
                            id="monitored-info-address"
                            onClick={() => window.addToDataLayer({ event: "Edit Address" })}
                        >
                            <span className="btn-text">
                                {tLang("identityVault.monitoredInformation.addressWidget.editButtonText")}
                                <span className="sr-only">{tLang("identityVault.monitoredInformation.addressWidget.title")}</span>
                            </span>
                            <span className="btn-icon">
                                <RenderIcons iconName="pen" />
                            </span>
                        </button>
                    </div>
                )}
            </div>
            <div className="box-content">
                {!showForm && (
                    <div role="grid" className="data-grid " id="monitored-info-address-grid" aria-hidden="false">
                        <div role="row" className="data-row row">
                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                <div role="gridcell" className="data-label" id="label-street-display1">
                                    {tLang("identityVault.monitoredInformation.addressWidget.label.street")}
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                <div role="gridcell" className="data-value" aria-labelledby="label-street-display1">
                                    {formData.address1}
                                </div>
                            </div>
                        </div>
                        <div role="row" className="data-row row">
                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                <div role="gridcell" className="data-label" id="label-street-display2"></div>
                            </div>
                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                <div role="gridcell" className="data-value" aria-labelledby="label-street-display2">
                                    {formData.address2.includes(';') ?  formData.address2.split(';')[0] : formData.address2}
                                </div>
                            </div>
                        </div>
                        {(formData.state==="PR"||formData.state==="Puerto Rico") && <div role="row" className="data-row row">
                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                <div role="gridcell" className="data-label" id="label-street-display2">Urbanization</div>
                            </div>
                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                <div role="gridcell" className="data-value" aria-labelledby="label-street-display2">
                                    {formData.address2.includes(';') ?  formData.address2.split(';')[1] : ""}
                                </div>
                            </div>
                        </div>}
                        <div role="row" className="data-row row">
                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                <div role="gridcell" className="data-label" id="label-city-display">
                                    {tLang("identityVault.monitoredInformation.addressWidget.label.city")}
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                <div role="gridcell" className="data-value" aria-labelledby="label-city-display">
                                    {formData.city}
                                </div>
                            </div>
                        </div>

                        {["us", "united states of america"].indexOf(formData.country.toLowerCase()) >= 0 ? (
                            <div role="row" className="data-row row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div role="gridcell" className="data-label" id="label-state-display">
                                        {tLang("identityVault.monitoredInformation.addressWidget.label.state")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="label-state-display">
                                        {stateList.find((s) => s.value === formData.state)?.name}
                                    </div>
                                </div>
                            </div>
                        ) : formData.country === "CA" || formData.country === "Canada" ? (
                            <div role="row" className="data-row row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div role="gridcell" className="data-label" id="label-state-display">
                                        {tLang("identityVault.monitoredInformation.addressWidget.label.province")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="label-state-display">
                                        {CAProvinces.find((s) => s.value === formData.state)?.name}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div role="row" className="data-row row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div role="gridcell" className="data-label" id="label-state-display">
                                        {tLang("identityVault.monitoredInformation.addressWidget.label.region")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="label-state-display">
                                        {formData.state}
                                    </div>
                                </div>
                            </div>
                        )}
                        <div role="row" className="data-row row">
                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                <div role="gridcell" className="data-label" id="label-zipcode-display">
                                    {["us", "united states of america", ""].indexOf(formData.country.toLowerCase()) >= 0
                                        ? tLang("identityVault.monitoredInformation.addressWidget.label.zipcode")
                                        : tLang("identityVault.monitoredInformation.addressWidget.label.postalCode") }
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                <div role="gridcell" className="data-value" aria-labelledby="label-zipcode-display">
                                    {formData.zipcode}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {showForm && (
                    <MonitoringAddressInfoForm
                        refreshDataCallback={ensureDataFetched}
                        setFormStatus={setShowForm}
                        IsIDFUser={isIDFUser}
                        personalInfo={personalAssets}
                        formData={formData}
                    />
                )}
            </div>
        </div>
    );
};

export default MonitoringAddressInfo;
